<template>
  <div class="businessTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('cooperation.buttons.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('cooperation.buttons.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="businessTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :loading="loading"
      highlight-current-row
      @current-change="currentChange"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'businessTable',
    components: {},
    data() {
      return {
        loading: false,
        tableData: [],
        del: [],
      };
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'orderCode',
            title: this.$t('businessType.businessTable.orderCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderName',
            title: this.$t('businessType.businessTable.orderName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderDesc',
            title: this.$t('businessType.businessTable.orderDesc'),
            editRender: {
              name: 'ElInput',
              defaultValue: '',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      rules() {
        return {
          orderCode: [
            { required: true, message: this.$t('businessType.businessTable.orderCodePlaceholder') },
          ],
          orderName: [
            { required: true, message: this.$t('businessType.businessTable.orderNamePlaceholder') },
          ],
        };
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.loading = true;
        this.$axios.post(API.QUERY_ORDERTYPE).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
          }
        });
      },
      currentChange(val) {
        this.$emit('row-change', val);
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.businessTable.validate((valid) => {
          console.log(valid);
          if (valid) {
            let record = {
              orderCode: null,
              orderName: null,
              orderDesc: null,
            };
            this.$refs.businessTable.insertAt(record, row).then(({ row }) => {
              this.$refs.businessTable.setActiveRow(row);
            });
          }
        });
      },
      handleDelete() {
        const selectedList = this.$refs.businessTable.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('businessType.msg.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.businessTable.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('businessType.msg.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('businessType.msg.cancelled'),
            });
          });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.businessTable.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('businessType.msg.noBusinessType'),
            type: 'error',
          });
          return false;
        } else {
          return new Promise((resolve) => {
            this.$refs.businessTable.validate((valid) => {
              if (valid) {
                let param = {
                  list: tableData,
                  del: this.del,
                };
                resolve(param);
              }
            });
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
